<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :style="svgStyle"
    :viewBox="viewBox"
  >
    <path
      d="M27.59,8.35,25.06,5.17a6.11,6.11,0,0,0-1.38-1L19.45,2.6a.88.88,0,0,0-.33-.06H9.32A1,1,0,0,0,9,2.6L4.77,4.18a5.9,5.9,0,0,0-1.38,1L.85,8.35a1,1,0,0,0-.19.87,7.76,7.76,0,0,0,.66,1.91S12.08,25.61,14.19,25.89v0h.07v0c2.1-.28,12.86-14.76,12.86-14.76a7.8,7.8,0,0,0,.67-1.91A1,1,0,0,0,27.59,8.35ZM10.3,3.87h7.84l3.38,1.26L18.39,6.48H10.05L6.92,5.13Zm-1.14,7.5.72-2.93a.45.45,0,0,1,.44-.32h7.81a.43.43,0,0,1,.43.32l.73,2.93Zm9.77,2-4.71,9.69L9.51,13.38ZM4.24,6.09,8,7.75l-.87,3.49L2,8.89Zm-.82,5.55s2.75,1.24,3.44,1.6A3.16,3.16,0,0,1,8,14.34l4.14,8.1Zm12.91,10.8,4.14-8.1a3.13,3.13,0,0,1,1.12-1.1c.68-.36,3.44-1.6,3.44-1.6Zm4.94-11.2-.86-3.49,3.8-1.66,2.23,2.8Z"
      :style="`fill: ${fill}`"
    />
  </svg>
</template>
<script>
export default {
  props: {
    viewBox: { type: String, default: '0 0 28.44 28.44' },
    fill: { type: String, default: '#FFFFFF' },
    svgClass: { type: String },
    svgStyle: { type: Object },
  },
};
</script>
